import { render } from "./IssuesList.vue?vue&type=template&id=6d43c130&scoped=true"
import script from "./IssuesList.vue?vue&type=script&lang=js"
export * from "./IssuesList.vue?vue&type=script&lang=js"

import "./IssuesList.vue?vue&type=style&index=0&id=6d43c130&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d43c130"]])

export default __exports__